import { z } from 'zod';

import { PrepareCurrentAccountBasicTerminationRequestAuthorisationTypeV1 } from '../../../../api/generated/cz.partners.bank.termination.account.cab.boa/index';

export const accountTerminationAuthorizationType =
	PrepareCurrentAccountBasicTerminationRequestAuthorisationTypeV1;

type GetAccountTerminationSummaryFormSchemaParams = {
	isAuthorizationTypeRequired: boolean;
};

export const getAccountTerminationSummaryFormSchema = ({
	isAuthorizationTypeRequired,
}: GetAccountTerminationSummaryFormSchemaParams) => {
	const authorizationType = z.enum(accountTerminationAuthorizationType);
	const authorizationTypeMaybeOptional = isAuthorizationTypeRequired
		? authorizationType
		: authorizationType.optional();

	return z.object({
		authorizationType: authorizationTypeMaybeOptional,
	});
};
export type AccountTerminationSummaryForm = z.infer<
	ReturnType<typeof getAccountTerminationSummaryFormSchema>
>;
